export default {
  index: "首页",
  self_service: "自助服务",
  order_center: "订单中心",
  help_center: "帮助中心",
  personal_center: '个人中心',
  my_business:'我的企业',
  user_business:'用户中心',
  warm: "温馨提示",
  special_booth: "特装服务",
  normal_booth: "标摊服务",
  self_apply: "自助申请服务",
  orinary: "常规订单",
  insurance: "保险订单",
  certificateOrder: "证件订单",
  notice: "通知",
  check_pass: "审图通过",
  check_fail: "审图未通过",
  modify_pwd: "修改密码",
  modify_personal: "修改资料",
  log_out: "退出登录",
  hello: "你好",
  company_bussiness: "公司业务",
  contact_us: "联系我们",
  address: "地址： 中国江苏省溧水区白马大道99号",
  phone: "电话：+86 25 57253555 / 57258228",
  email: "邮件：info@js-aec.com",
  service_guide: "服务指南",
  check_special: "特装审图",
  fixed_fee: "报馆费用缴纳",
  equipment_rent: "水电展具租赁",
  foregift_refund: "申请退押金",
  invoice: "申请发票",
  wechat: "微信公众号",
  miniprogram: "小程序",
  operation_manual: "操作手册",
  个人中心: "个人中心",
  修改个人资料: "修改个人资料",
  修改密码: "修改密码",
  第三方账户信息: "第三方账户信息",
  昵称: "昵称",
  邮箱: "邮箱",
  手机: "手机",
  旧密码: "旧密码",
  新密码: "新密码",
  确认密码: "确认密码",
  解绑: "解绑",
  绑定其他账户: "绑定其他账户",
  微信: "微信",
  支付宝: "支付宝",
  两次输入密码不一致: "两次输入密码不一致",

  oldpassword_label: "旧密码",
  newpassword_label: "新密码",
  confirmpassword_label: "确认新密码",
  title_pwd: "修改密码",
  confirm_btn: "确定",
  return_btn: "返回",
  oldpassword_placeholder: "请输入您的旧密码",
  newpassword_placeholder: "请输入您的新密码",
  confirmpassword_placeholder: "请再次输入您的新密码",
  title_info: "修改个人资料",
  nickname_label: "昵称",
  email_label: "邮箱",
  mobile_label: "手机号",
  nickname_placeholder: "请输入您的昵称",
  email_placeholder: "请正确输入您的邮箱",
  mobile_placeholder: "请正确输入您的手机号",

  QQ: "QQ",
  ALIPAY: "支付宝",

  管理后台: "管理后台",

  展览会主场运营服务: "展览会主场运营服务",
  展览馆驻场服务: "展览馆驻场服务",
  活动与体育赛事服务: "活动与体育赛事服务",
  企业品牌服务: "企业品牌服务",
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/index.js